import {DataObject} from "./dataObject";
//import store from "@/store/store";
import FirebaseWrite from "@/services/database/firebaseWrite";

export class SaisonTable extends DataObject {
    constructor(teams){
        super();
        const teamsLoc = JSON.parse(JSON.stringify(teams));
        this.teamsList = this.getArrayFromMap(teamsLoc).map(
            team => {
                team.tabPkt = team.tabPkt ? team.tabPkt : 0;
                team.spiele = team.spiele ? team.spiele : 0;
                team.siege = team.siege ? team.siege : 0;
                team.niederlagen = team.niederlagen ? team.niederlagen : 0;
                team.unentschieden = team.unentschieden ? team.unentschieden : 0;
                team.satzpunkteS = team.satzpunkteS ? team.satzpunkteS : 0;
                team.satzpunkteN = team.satzpunkteN ? team.satzpunkteN : 0;
                team.mannschaftsPunkteS = team.mannschaftsPunkteS ? team.mannschaftsPunkteS : 0;
                team.mannschaftsPunkteN = team.mannschaftsPunkteN ? team.mannschaftsPunkteN : 0;
                return team;
            }
        );
    }

    async saveTable(documentId){
        if ( this.teamsList.length <= 1 ) { return }
        this.formatTextToNumber();
        const dataObject = this.getDataObjectForUpdate();
        console.log ("dataObject", dataObject);
        return FirebaseWrite.update('saisonen', documentId,
            dataObject
        )
    }

    formatTextToNumber(){
        this.teamsList.forEach( (team) => {
            const fieldList = ['tabPkt','spiele','siege','niederlagen','unentschieden',
                'satzpunkteS','satzpunkteN','mannschaftsPunkteS','mannschaftsPunkteN'];
            this.checkAndSetValue(team, fieldList)
        });
    }
        checkAndSetValue(team, fieldList){
            fieldList.forEach( (field) => {
                team[field] = team[field] ? parseFloat(team[field]) : 0;
            });
        }

    getDataObjectForUpdate(){
        const dataObject = {teams: {}};
        this.teamsList.forEach( (team) => {
            const id = team.id;
            delete team.id;
            dataObject.teams[id] = team;
        });
        return dataObject;
    }
}